import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Post } from "../../types/types";

interface ExactPostState {
    post: Post | null;
    status: "idle" | "loading" | "succeeded" | "failed";
    error: string | null;
}

export const fetchPostById = createAsyncThunk<Post, number, { rejectValue: string }>(
  "exactPost/fetchPostById",
  async (postId, { rejectWithValue }) => {
    try {
      const API_URL = process.env.REACT_APP_URL_BACKEND;
      const response = await fetch(`${API_URL}/api/v1/posts/${postId}/`);

      if (!response.ok) {
        return rejectWithValue("Ошибка загрузки поста");
      }

      const post: Post = await response.json();

      return post;
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }

      return rejectWithValue("Неизвестная ошибка");
    }
  }
);

const initialState: ExactPostState = {
  post: null,
  status: "idle",
  error: null,
};

const exactPostSlice = createSlice({
  name: "exactPost",
  initialState,
  reducers: {
    resetExactPost(state) {
      state.post = null;
      state.status = "idle";
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPostById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPostById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.post = action.payload;
      })
      .addCase(fetchPostById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload ?? "Ошибка загрузки";
      });
  },
});

export const { resetExactPost } = exactPostSlice.actions;

export default exactPostSlice.reducer;

